import styled from 'styled-components';

const Container = styled.div`
  transform: translate(0);
  margin-top: calc(4.9vw + 20px);
`;

export default Container;
